import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from '../../../components/SnackbarProvider';
import { BillableMaterialsService } from '../../generated';
import { billableMaterialsKeys } from '../../queries/billableMaterials';

interface DeleteBillableMaterialProps {
  organisationId: string;
  billableMaterialId: string;
}

export function useDeleteBillableMaterial() {
  const { showSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ organisationId, billableMaterialId }: DeleteBillableMaterialProps) => {
      const response = await BillableMaterialsService.billableMaterialControllerDeleteBillableMaterial({
        path: {
          organisationId,
          billableMaterialId,
        },
      });
      if (response.error) {
        throw (
          (response as any).error ||
          new Error(response?.response?.statusText || 'Unknown error when creating billable material')
        );
      }
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: billableMaterialsKeys.base() });
      showSnackbar('billableMaterial.deleteSuccess', 'success');
    },
    onError: async () => {
      showSnackbar('billableMaterial.deleteError', 'error');
    },
  });
}
